import {Route, Routes} from 'react-router-dom';
import NewsOverview, {NewsLanding} from './overview/NewsOverview';
import SelectedNews from 'components/investorUpdate/management/selectedNews/SelectedNews';
import AddNews from 'components/investorUpdate/management/news/AddNews/AddNews';
import EditNews from 'components/investorUpdate/management/news/editNews/EditNews';
import WebsiteNews from './websiteNews/WebsiteNews';
import CreateWebsiteNews from './create/CreateWebsiteNews';
import UpdateWebsiteNews from './update/UpdateWebsiteNews';
import UpdateWebsiteNewsFinishPage from './update/UpdateWebsiteNewsFinishPage';
import WebsiteNewsFinishPageContents from './create/WebsiteNewsFinishPageContents';
import NewsSources from './sources/NewsSources';
import NewsSourceDetail from './sources/NewsSourceDetail';
import NewsActivity from './activity/NewsActivity';
import NewsReview from './review/NewsReview';
import NewsDraftReview from './review/NewsDraftReview';

const NewsPageRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<NewsOverview />}>
        <Route index element={<NewsLanding />} />
        <Route path="/selected-news" element={<SelectedNews />} />
        <Route path="website-news" element={<WebsiteNews />} />
        <Route path="sources" element={<NewsSources />} />
        <Route path="activity" element={<NewsActivity />} />
        <Route path="review" element={<NewsReview />} />
      </Route>
      <Route path="review/:draftId" element={<NewsDraftReview />} />
      <Route path="sources/:sourceId" element={<NewsSourceDetail />} />
      <Route path="/add-news" element={<AddNews />} />
      <Route path="/update-news/:id" element={<EditNews />} />
      <Route path="create-website-news" element={<CreateWebsiteNews />} />
      <Route
        path="create-website-news-two"
        element={<WebsiteNewsFinishPageContents />}
      />
      <Route
        path="update-website-news/:id/:lang"
        element={<UpdateWebsiteNews />}
      />
      <Route
        path="update-website-news-two/:id/:lang"
        element={<UpdateWebsiteNewsFinishPage />}
      />
    </Routes>
  );
};

export default NewsPageRoutes;
